<script setup lang="ts">
    import { useForm } from '@inertiajs/vue3';
    import { Button } from '@/components/ui/button';
    import { Input } from '@/components/ui/input';
    import { Label } from '@/components/ui/label';
    import { InputRow } from '@/components/ui/form';
    import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/ui/card';
    import { ref } from 'vue';
    import { toast } from 'vue-sonner';

    const form = useForm({
        current_password: '',
        password: '',
        password_confirmation: '',
    });

    const passwordInput = ref<HTMLInputElement | null>(null);
    const currentPasswordInput = ref<HTMLInputElement | null>(null);

    const submit = () => {
        form.put(route('v2.profile.password.update'), {
            preserveScroll: true,
            onSuccess: () => {
                toast.success('Adgangskode opdateret');
                form.reset();
            },
            onError: (errors: any) => {
                if (errors.password) {
                    form.reset('password', 'password_confirmation');
                    if (passwordInput.value instanceof HTMLInputElement) {
                        passwordInput.value.focus();
                    }
                }

                if (errors.current_password) {
                    form.reset('current_password');
                    if (currentPasswordInput.value instanceof HTMLInputElement) {
                        currentPasswordInput.value.focus();
                    }
                }
            },
        });
    };
</script>

<template>
    <Card class="w-full max-w-lg self-center">
        <CardHeader>
            <div class="flex items-center gap-2">
                <CardTitle>{{ $t('profile.update_password') }}</CardTitle>
            </div>
        </CardHeader>

        <form @submit.prevent="submit">
            <CardContent class="space-y-5">
                <InputRow
                    :form="form"
                    name="current_password"
                    label="forms.password_current"
                >
                    <Input
                        id="current_password"
                        ref="currentPasswordInput"
                        v-model="form.current_password"
                        type="password"
                        autocomplete="current-password"
                        :placeholder="$t('forms.password_current')"
                    />
                </InputRow>

                <InputRow
                    :form="form"
                    name="password"
                    label="forms.password_new"
                >
                    <Input
                        id="password"
                        ref="passwordInput"
                        v-model="form.password"
                        type="password"
                        autocomplete="new-password"
                        :placeholder="$t('forms.password_new')"
                    />
                </InputRow>
                <InputRow
                    :form="form"
                    name="password_confirmation"
                    label="forms.password_new_confirm"
                >
                    <Input
                        id="password_confirmation"
                        v-model="form.password_confirmation"
                        type="password"
                        autocomplete="new-password"
                        :placeholder="$t('forms.password_new_confirm')"
                    />
                </InputRow>
            </CardContent>
            <CardFooter class="border-t">
                <Button
                    :disabled="form.processing || !form.isDirty"
                    :loading="form.processing"
                >
                    {{ $t('profile.update_password') }}
                </Button>
            </CardFooter>
        </form>
    </Card>
</template>
